import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-location",
  "use": "icon-map-location-usage",
  "viewBox": "0 0 18 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 22\" id=\"icon-map-location\">\n<style type=\"text/css\">\n\t#icon-map-location .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<path class=\"st0\" d=\"M9,0C4.03,0,0,4.32,0,9c0,4.68,3.94,8.28,9,13c5.07-4.77,9-8.32,9-13C18,4.32,13.97,0,9,0z M9,11\n\tc-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3S10.66,11,9,11z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol